import { Box, Stack, Typography } from "@mui/material";
import { TeamMember } from "./tableConfig/types";
import { TEAM_STATUS_OPTIONS } from "../constants";

type TeamMemberStatusProps = {
  status: TeamMember["status"];
};

const TeamMemberStatus = ({ status }: TeamMemberStatusProps) => {
  const { label, color, backgroundColor } = TEAM_STATUS_OPTIONS[status];

  return (
    <Stack
      direction='row'
      alignItems='center'
      spacing={0.75}
      sx={{
        width: "fit-content",
        borderRadius: 999,
        backgroundColor,
        color,
        px: 1.125,
        py: 0.375,
      }}>
      <Box
        sx={{
          width: 6,
          height: 6,
          borderRadius: "50%",
          backgroundColor: "currentColor",
        }}
      />
      <Typography
        variant='body14rg'
        color='inherit'
        sx={{ fontWeight: 600 }}>
        {label}
      </Typography>
    </Stack>
  );
};

export default TeamMemberStatus;
